module.exports = __webpack_public_path__ + "img/vaughn-back-patio.b0255e37.webp";